export default __webpack_public_path__ + "static/4-31dcc0f34d1e1f1bd8f5e16c990b4193.jpg";